import type { Leco, LockedContent } from '@/api/learning.types';

const NAVIGABLE_LOCKED_TYPES: ReadonlyArray<LockedContent['type']> = [
  'milestone',
  'crash_course',
  'event',
  'scorm',
  'video',
  'text',
  'single_learning',
  'questions_only',
];

export const getLockedContentDeeplink = (locked: LockedContent): string => {
  switch (locked.type) {
    case 'milestone':
      return `/academy/milestones/${locked.id}`;
    case 'crash_course':
      return `/academy/crash-course/${locked.id}`;
    case 'event':
      return `/academy/event/${locked.id}`;
    case 'scorm':
      return `/academy/scorm/${locked.id}`;
    case 'video':
      return `/academy/video/${locked.id}`;
    case 'text':
    case 'single_learning':
    case 'questions_only':
      return `/academy/learning-moment/${locked.id}`;
    default:
      return `/academy/learning-path/${locked.id}`;
  }
};

export const isLockedContentNavigable = (locked: LockedContent): boolean =>
  NAVIGABLE_LOCKED_TYPES.includes(locked.type);

export const getAcademyDeeplink = (leco: Leco): string => {
  switch (leco.type) {
    case 'milestone':
      return `/academy/milestones/${leco.content.id}`;
    case 'crash_course':
      return `/academy/crash-course/${leco.id}`;
    case 'event':
      return `/academy/event/${leco.content.lecoId}`;
    case 'scorm':
      return `/academy/scorm/${leco.content.id}`;
    case 'video':
      return `/academy/video/${leco.content.id}`;
    case 'text':
    case 'single_learning':
    case 'questions_only':
      return `/academy/learning-moment/${leco.content.id}`;
    default:
      return `/academy/learning-path/${leco.id}`;
  }
};

export const isLecoLocked = (leco: Leco): boolean =>
  Array.isArray(leco.content.lockedBy) && leco.content.lockedBy.length > 0;
